/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelPnnSchedule.ts                   *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/dispatch/pnn-schedule";

export class AutogenModelPnnSchedule<RowType extends ModelRow> extends Endpoint<RowType, RowPnnScheduleFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowPnnSchedule extends ModelRow<RowPnnScheduleFields> {
	constructor(values?: Partial<RowPnnScheduleFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowPnnScheduleFields {
	company_id: string;
	descr: string;
	id: string;
}

